import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import React from "react";
import image from "../../../public/images/satrang23event2.jpeg";

const Event2 = () => {
  return (
    <Card>
      <CardMedia
        sx={{ height: [400, 700], backgroundSize: "contain" }}
        image={image}
        title="green iguana"
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          Aaware
        </Typography>
      </CardContent>
    </Card>
  );
};

export default Event2;
